import { yup } from './yup';

export const schemaLogin = yup.object().shape({
    email: yup.string().required().email(),
    senha: yup.string().required().min(5),
});
